import { CSSProperties } from 'react'
import './BoxContainer.css'

type BoxContainerProps = {
  visible: boolean,
  position: CSSProperties,
  titleBox?: string,
  titleDescription: string[],
  description: string[],
  asInfoBlock?: boolean
}

export default function BoxContainer(props: BoxContainerProps) {

  const RowData = (left: string[], right: string[]) => {
    return (
      <div style={{display:"flex", flex: 1 ,flexDirection: "column", justifyContent:"space-between",gap: "16px"}}>
        {left.map(function (leftString, index) {
          return (
            Row(leftString,right[index])
          )
        })}
      </div>
    )
  }

  const Row = (left: string, right:string) => {
    return (
      <div style={{display:"flex", flexDirection:"row"}}>
        <div className='left-text-mobile' style={{display: "flex", flex: 1}}>
          {left}
        </div>
        <div className='right-text-mobile' style={{fontWeight:600}}>
         {right}
        </div>
      </div>
    )
  }

  return (
    
    <div className='box-container-mobile'  style={props.position}>
      <div style={{fontWeight:600, fontSize: "20px"}}>{props.titleBox}</div>
      {props.asInfoBlock == false ? RowData(props.titleDescription, props.description) : <></>}
      {props.asInfoBlock == true ? <>
          <div style={{ display: "flex", flex: 1, flexDirection: "column", justifyContent: "space-between", gap: "16px" }}>
            {/* sezione model name */}
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div className='left-text-mobile' style={{ display: "flex", flex: 1  }}>
                {props.titleDescription[0]}
              </div>
              <div className='right-text-mobile' style={{ fontWeight: 600 }}>
                {props.description[0]}
              </div>
            </div>
            {/* sezione materiale */}
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div className='left-text-mobile' style={{ display: "flex", flex: 1 }}>
                {props.titleDescription[1]}
              </div>
              <div className='right-text-mobile' style={{  fontWeight: 600 }}>
                {props.description[1]}
              </div>
            </div>
            {/* sezione dimension only */}
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div className='left-text-mobile' style={{ display: "flex", flex: 1 }}>
                {props.titleDescription[2]}
              </div>
            </div>
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "end" }}>
              <div className='right-text-mobile' style={{ fontWeight: 600 }}>
                {props.description[2]}
              </div>
            </div>
            <div style={{ display: "flex", flexDirection: "row", justifyContent:"end" }}>
              <div className='right-text-mobile' style={{  fontWeight: 600 }}>
                {props.description[3]}
              </div>
            </div>
          </div>
        </> : <></>}
    </div>
  )
}